import React from 'react';
import { useTheme } from '@mui/material';
import DSBox from '../../../../design-system/DSBox';
import DSDialog from '../../../../design-system/DSDialog';
import DSDialogTitle from '../../../../design-system/DSDialogTitle';
import DSDialogContent from '../../../../design-system/DSDialogContent';
import DSDialogActions from '../../../../design-system/DSDialogActions';
import DSTextField from '../../../../design-system/DSTextField';
import DSSecondaryButton from '../../../../design-system/DSSecondaryButton';
import { DSTypography } from '../../../../design-system/Typography';
import { KlydoReviewState } from '../../../../api/klydo';
import { REVIEW_COMMENT_LIMIT } from '../../../../consts/textFieldsLimitations';

type KlydoReviewDialogProps = {
  reviewStatus: KlydoReviewState;
  comment: string;
  onCommentChange: (comment: string) => void;
  onClose: () => void;
};

/** The reply is held like any other edited field; the resubmission stores it. */
const KlydoReviewDialog: React.FC<KlydoReviewDialogProps> = ({
  reviewStatus,
  comment,
  onCommentChange,
  onClose,
}) => {
  const { spacing, palette } = useTheme();

  return (
    <DSDialog open onClose={onClose} fullWidth maxWidth="xs">
      <DSDialogTitle>Review message</DSDialogTitle>
      <DSDialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: spacing(2) }}
      >
        <DSBox
          sx={{
            background: palette.secondary.main,
            borderRadius: spacing(2),
            padding: spacing(2),
          }}
        >
          <DSTypography variant="label" fontSize={12}>
            Reviewer note
          </DSTypography>
          <DSTypography
            variant="body1"
            fontSize={14}
            color={palette.text.primary}
          >
            {reviewStatus.message || 'No note was left with this decision.'}
          </DSTypography>
        </DSBox>
        <DSTextField
          autoFocus
          fullWidth
          multiline
          minRows={2}
          placeholder="Add a comment for the reviewer..."
          value={comment}
          slotProps={{
            input: {
              inputProps: { maxLength: REVIEW_COMMENT_LIMIT },
            },
          }}
          onChange={(event) => onCommentChange(event.target.value)}
        />
        <DSTypography variant="body1" fontSize={12} alignSelf="flex-end">
          {comment.length}/{REVIEW_COMMENT_LIMIT}
        </DSTypography>
      </DSDialogContent>
      <DSDialogActions>
        <DSSecondaryButton onClick={onClose}>Close</DSSecondaryButton>
      </DSDialogActions>
    </DSDialog>
  );
};

export default KlydoReviewDialog;
